import { ExtendedRefs, FloatingContext, ReferenceType } from '@floating-ui/react';
import { createContext } from 'react';

export interface DropdownContextValue {
  toggle: (e?: React.SyntheticEvent | KeyboardEvent | MouseEvent) => void;
  isOpen: boolean;
  direction: 'up' | 'down' | 'left' | 'right';
  inNavbar: boolean;
  disabled?: boolean;
  onMenuRef?: (ref: HTMLElement | null) => void;
  menuRole?: 'listbox' | 'menu';
  refs?: ExtendedRefs<ReferenceType>;
  floatingStyles?: React.CSSProperties;
  floatingContext?: FloatingContext;
  placement?: string;
}

export const DropdownContext = createContext<DropdownContextValue>({
  toggle: () => {},
  isOpen: false,
  direction: 'down',
  inNavbar: false
});
